import { render, staticRenderFns } from "./ChangeRequests.vue?vue&type=template&id=2dbc20b0&scoped=true"
import script from "./ChangeRequests.vue?vue&type=script&lang=js"
export * from "./ChangeRequests.vue?vue&type=script&lang=js"
import style0 from "./ChangeRequests.vue?vue&type=style&index=0&id=2dbc20b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc20b0",
  null
  
)

export default component.exports